export default __webpack_public_path__ + "static/media/gallery-wip-neck_05.3049f398.jpg";